/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DhlValidationsControllerService } from './services/dhl-validations-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';
import { DhlAddressControllerService } from './services/dhl-address-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DhlValidationsControllerService,
    MySvgControllerService,
    DhlAddressControllerService,
    ApiConfiguration
  ],
})
export class DhlAddressesModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<DhlAddressesModule> {
    return {
      ngModule: DhlAddressesModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DhlAddressesModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DhlAddressesModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
